import { useState } from 'react';
import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import DramaCard from '@/components/feature/DramaCard';

const tabs = ['全部', '爱情', '悬疑', '历史', '奇幻', '都市'];

export default function LatestSection() {
  const [active, setActive] = useState('全部');

  const list = [...dramas]
    .filter((d) => (active === '全部' ? true : d.genres.includes(active)))
    .sort((a, b) => b.year - a.year || b.heat - a.heat)
    .slice(0, 8);

  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">最新韩剧推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">按上线时间与热度排序，不错过每一部值得追的新剧</p>
        </div>
        <div className="flex flex-wrap items-center gap-1 bg-background-100 border border-background-200 rounded-full p-1">
          {tabs.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`cursor-pointer whitespace-nowrap text-sm px-4 py-1.5 rounded-full transition-colors ${
                active === t ? 'bg-primary-500 text-white font-medium' : 'text-foreground-600 hover:text-primary-600'
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {list.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-5">
          {list.map((d) => (
            <DramaCard key={d.id} drama={d} />
          ))}
        </div>
      ) : (
        <div className="rounded-lg border border-background-200 bg-background-100 py-16 text-center">
          <i className="ri-emotion-sad-line text-3xl text-foreground-300"></i>
          <p className="mt-3 text-sm text-foreground-500">该题材暂无剧集</p>
        </div>
      )}

      <div className="mt-8 text-center">
        <Link
          to="/category/romance"
          className="inline-flex items-center gap-1 cursor-pointer whitespace-nowrap border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium px-6 py-3 rounded-full transition-colors"
        >
          浏览全部题材 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}